import(/* webpackMode: "eager" */ "/app/src/app/tools/page.tsx");
